import { gsap } from 'gsap';
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import InfiniteScroll from 'infinite-scroll';

export class ArticlesPageHandler extends PageHandler {
    constructor(id) {
    	super(id);
    }

    init() {
		gsap.set(".instagram__post:nth-child(-n + 25)", {autoAlpha: 0, y: 100});
		ScrollTrigger.batch(".instagram__post:nth-child(-n + 25)", {
			//interval: 0.1, // time window (in seconds) for batching to occur. 
			//batchMax: 3,   // maximum batch size (targets)
			onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
			// you can also define things like start, end, etc.
		});

		function updateNextURL( doc ) {
			window.nextURL = jQuery( doc ).find('.pagination__next').attr('href');
		}

		// get initial nextURL
		// updateNextURL( document );

		var grid = document.querySelector('.instagram-posts');
		var msnry = new Masonry( grid, {
			// options...
			itemSelector: '.instagram__post-container',
			gutter: '.gutter-item',
			horizontalOrder: true,
			hiddenStyle: {
				transform: 'translateY(100px)',
				opacity: 0,
			},
			visibleStyle: {
				transform: 'translateY(0px)',
				opacity: 1
			},
			transitionDuration: '0.6s'
		});

		// InfiniteScroll.imagesLoaded = imagesLoaded;
		// let infScroll = new InfiniteScroll( '.instagram-posts', {
		// 	// Infinite Scroll options...
		// 	append: '.instagram__post-container',
		// 	outlayer: msnry,
		// 	history: false,
		// 	scrollThreshold: 100,
		// 	status: '.page-load-status',
		// 	path: function() {
		// 		return window.nextURL;
		// 	},
		// });

		// infScroll.on('load', function(body, path, response) {
		// 	// console.log(`Loaded: ${path}`);
		// 	updateNextURL(body)
		// 	ScrollTrigger.refresh();
		// })

		msnry.on( 'layoutComplete', function( laidOutItems ) {
			ScrollTrigger.refresh();
			
		} )
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
		// gsap.fromTo('.articles .intro', {backgroundSize: "600%"}, {backgroundSize: "100%", duration: 0.5, ease: 'power2.inout'});
	}
}